import { AsyncPipe, NgForOf, NgIf, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { TuiDestroyService, TuiLetModule } from '@taiga-ui/cdk';
import { TuiButtonModule, TuiModeModule } from '@taiga-ui/core';
import { TuiCarouselModule } from '@taiga-ui/kit';
import { ResponsiveStore } from '@us/web/shared/data-access';
import { BehaviorSubject, map, takeUntil, tap, timer } from 'rxjs';

@Component({
    selector: 'us-product-photo',
    standalone: true,
    imports: [
        NgIf,
        TuiCarouselModule,
        TuiButtonModule,
        TuiModeModule,
        NgForOf,
        NgOptimizedImage,
        AsyncPipe,
        TuiLetModule,
        LetDirective
    ],
    providers: [TuiDestroyService],
    templateUrl: './product-photo.component.html',
    styleUrls: ['./product-photo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPhotoComponent implements OnInit {
    private readonly responsiveStore = inject(ResponsiveStore);
    private readonly destroy$ = inject(TuiDestroyService, { self: true });

    @Input() photos: string[] = [];
    readonly photoIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    readonly imageSize$ = this.responsiveStore.breakpoint$.pipe(
        map(breakpoint => {
            switch (breakpoint) {
                case 'xs':
                case 'sm':
                    return { width: 356, height: 178, aspect: 'aspect-[2/1]' };
                default:
                    return { width: 480, height: 480, aspect: 'aspect-square' };
            }
        })
    );

    ngOnInit() {
        if (this.photos.length > 1) {
            this.startAutoPlay();
        }
    }

    selectImage(i: number) {
        this.photoIndex$.next(i);
    }

    navigate(delta: number): void {
        const index = (this.photoIndex$.value + delta) % this.photos.length;
        this.photoIndex$.next(index < 0 ? this.photos.length - 1 : index);
    }

    private startAutoPlay() {
        timer(5000, 5000)
            .pipe(
                takeUntil(this.destroy$),
                tap(() => this.navigate(1))
            )
            .subscribe();
    }
}
